import { useMemo } from 'react';

import { useFeatureFlags } from 'Utilities/hooks';

import { ContentType } from '../utilities/WordpressConstants';

import { WordpressState } from './useWPData';

type UseContentProps = Pick<WordpressState, 'data' | 'empty' | 'error' | 'isAuthorDetails' | 'isGuideAuthors' | 'isBlog' | 'isPage'>;

export const useContentType = ({
  data,
  empty,
  error,
  isAuthorDetails,
  isBlog,
  isGuideAuthors,
  isPage,
}: UseContentProps) => {
  const { showWordpressGuideAuthorsPage } = useFeatureFlags();

  const contentType = useMemo((): ContentType => {
    if (isPage && !data?.content) {
      return ContentType.ERROR;
    }

    if (showWordpressGuideAuthorsPage) {
      if ((isAuthorDetails || isGuideAuthors) && (error || !data || !data.title)) {
        return ContentType.ERROR;
      }
      if (isAuthorDetails) {
        return ContentType.AUTHOR_DETAILS;
      }

      if (isGuideAuthors) {
        return ContentType.AUTHOR;
      }
    }

    if (isPage) {
      return ContentType.PAGE;
    }

    if (isBlog && empty) {
      return ContentType.EMPTY;
    }

    if (isBlog) {
      return ContentType.BLOG;
    }
    return ContentType.ERROR;
  }, [
    isPage,
    data,
    error,
    isAuthorDetails,
    isGuideAuthors,
    isBlog,
    empty,
    showWordpressGuideAuthorsPage,
  ]);

  return { contentType };
};
